/**
 * PM Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TranslateProductAttributesDto { 
    translationType: TranslateProductAttributesDto.TranslationTypeEnum;
    objectId: string;
    translationText: string;
}
export namespace TranslateProductAttributesDto {
    export const TranslationTypeEnum = {
        productAttribute: 'productAttribute',
        productAttributeOption: 'productAttributeOption'
    } as const;
    export type TranslationTypeEnum = typeof TranslationTypeEnum[keyof typeof TranslationTypeEnum];
}


